import React from 'react';
import { getImageUrl } from '../../utils/assets';
import './Loading.css';

interface LoadingProps {
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({ text = 'Loading...' }) => {
  const loadingImage = getImageUrl('gameplay/loading_image.png');
  const loadingTextBg = getImageUrl('gameplay/loading_text_bg.png');

  return (
    <div className="loading-overlay">
      <div 
        className="loading-spinner" 
        style={{ backgroundImage: `url(${loadingImage})` }} 
      />
      <div className="loading-text-wrapper">
        <img src={loadingTextBg} className="loading-text-bg" alt="" />
        <span className="loading-text">{text}</span>
      </div>
    </div>
  );
};

export default Loading;
